export default "__VITE_ASSET__BU_X27ME__"